export enum BrancheCode {
  MRI = 'MRI',
  CBNO = 'CBNO',
  GLI = 'GLI',
  CHO = 'CHO',
  EMP = 'EMP',
  PJ = 'PJ',
}
